
// ABOUTME: Role hub page for browsing and submitting referrals
// ABOUTME: Contains the referral submission flow with proper URL routing

import React from 'react';
import ReferralSubmissionFlow from '@/components/ReferralSubmissionFlow';
import { useNavigate } from 'react-router-dom';

const RoleHub = () => {
  const navigate = useNavigate();

  const handleViewChange = (view: string) => {
    switch (view) {
      case 'dashboard':
        navigate('/');
        break;
      case 'public-profile':
        navigate('/my-profile');
        break;
      case 'hr-dashboard':
        navigate('/hr');
        break;
      case 'manage-roles':
        navigate('/manage-roles');
        break;
      case 'billing':
        navigate('/billing');
        break;
      case 'security-audit':
        navigate('/security-audit');
        break;
      default:
        navigate('/');
    }
  };

  return <ReferralSubmissionFlow onViewChange={handleViewChange} />;
};

export default RoleHub;
